// extracted by mini-css-extract-plugin
module.exports = {"tile":"abo_i2"};